'use client';

import React from 'react';
import classNames from 'classnames';
import { IReviewQuote } from '@sapientpro/sapientpro-data-models';
import { useAtomValue } from 'jotai';
import styles from './TextReviewCard.module.scss';
import Img from '../../../components/Img';
import { theme, Theme } from '../../../store/theme';
import Button, { ButtonVariants } from '../../../components/Button';
import AnimatedTitle, { AnimationType } from '../../../components/AnimatedTitle';

interface IProps {
  textReview: IReviewQuote;
}

const TextReviewCard = ({ textReview }: IProps) => {
  const appTheme = useAtomValue<Theme>(theme);

  const handleJoinUsClick = () => {
    const element = document.getElementById('contact-form');

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className={styles.textReviewCard}>
      <div className={styles.container}>
        <div className={styles.avatar}>
          <div className={styles.avatarImage}>
            <Img
              src={textReview?.author.avatar.url}
              alt={textReview?.author.avatar.alternativeText || 'author avatar'}
              className={styles.image}
              key={appTheme}
            />
          </div>
          <div>
            <p className={styles.name}>{textReview?.author.name}</p>
            <p className={styles.position}>{textReview?.author.position}</p>
          </div>
        </div>

        <div className={styles.review}>
          <h3 className={classNames('sectionTitle', styles.title)}>
            <AnimatedTitle
              title={`”${textReview?.feedBack || ''}”`}
              animationType={AnimationType.MULTIPLE}
            />
          </h3>
          <p className={styles.text}>
            Looking for a reliable tech partner?
          </p>
        </div>
      </div>
      <Button
        className={styles.button}
        variant={ButtonVariants.PRIMARY}
        icon={(
          <svg>
            <use
              xlinkHref='/media/icon-nest.svg#iconNest'
              href='/media/icon-nest.svg#iconNest'
            />
          </svg>
        )}
        iconPosition='right'
        iconSize={{ width: 24, height: 24 }}
        onClick={handleJoinUsClick}
      >
        Talk to an expert
      </Button>
    </div>
  );
};

export default TextReviewCard;
